import React from 'react';

import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';

import PlacementCardLayout from './placementCardLayout';
import PlacementInfo from './placementInfo';

interface PendingPlacementCardProps {
  placement: AssociateProfilePlacement;
}

const PendingPlacementCard = ({ placement }: PendingPlacementCardProps) => (
  <PlacementCardLayout placement={placement}>
    <PlacementInfo label="Injury" value={placement.injury} />
    <PlacementInfo label="Start Date" value={new Date(placement.startAt).toLocaleDateString()} />
    <PlacementInfo label="End Date" value={new Date(placement.endAt).toLocaleDateString()} />
    <PlacementInfo label="Time In Pending" value={placement.timeInStatus} />
    <PlacementInfo label="Job(s)" value={placement.allocatedJobShifts.length} />
  </PlacementCardLayout>
);

export default PendingPlacementCard;
